import { FC } from "react";
import { Controller } from "react-hook-form";
import { PLATFORM_MODULES_OPTIONS } from "@miplatform/constants";
import { ITransferListItem } from "@miplatform/types";
import { TransferList } from "@mibuildweb/components";
import { ConfigAccordionHeader } from "../../../components/ConfigAccordionHeader/ConfigAccordionHeader";
import { DepartmentDetailsConfigViewProps } from "../../ConfigDepartments.types";

export const DepartmentConfigModulesTabView: FC<
  DepartmentDetailsConfigViewProps
> = ({ form }) => {
  const availableModules: ITransferListItem[] = PLATFORM_MODULES_OPTIONS.map(
    (module) => ({
      ...module,
      key: module.value,
      title: module.label,
    })
  ).sort((a, b) => a.title.localeCompare(b.title));

  return (
    <ConfigAccordionHeader title="Modules">
      <Controller
        control={form.control}
        name="modules"
        render={({ field }) => {
          const selectedValues: ITransferListItem[] = field.value
            .map((module: string) => ({
              key: module,
              title:
                PLATFORM_MODULES_OPTIONS.find(
                  (option) => option.value === module
                )?.label || module,
              value: module,
            }))
            .sort((a, b) => a.title.localeCompare(b.title));

          const handleAddItem = (key: string) => {
            const modules = [...field.value, key];
            field.onChange(modules);
          };

          const handleRemoveItem = (key: string) => {
            const modules = field.value.filter(
              (module: string) => module !== key
            );
            field.onChange(modules);
          };

          return (
            <TransferList
              availableItems={availableModules}
              selectedItems={selectedValues}
              onAddItem={handleAddItem}
              onRemoveItem={handleRemoveItem}
            />
          );
        }}
      />
    </ConfigAccordionHeader>
  );
};
